module.exports = __webpack_public_path__ + "assets/img/o3.9fef2266.png";